import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {Row, Col, Button} from 'reactstrap';

export class NotFoundPage extends Component {
    static displayName = NotFoundPage.name;

    render() {
        return (
                <Row>
                    <Col>
                        <h1>Niet gevonden</h1>
                        <p>De pagina die u probeert te openen kan niet worden gevonden. Controleer de url.</p>
                        <Button tag={Link} color="link" to="/" >Of ga terug naar de hoofdpagina</Button>
                    </Col>
                </Row>
        );
    }
}